import RequestFundsCont from '../../../components/Sales/Invoices/RequestFunds/RequestFundsCont'
import PaymentButton from '../../../components/Sales/Invoices/PaymentButton'
import { get } from 'lodash'
import React, { Fragment } from 'react'
import { Button, Tag } from 'antd'
import { filterCheckedColumns, idMaker } from '../../../modules/Utils'
import InfoText from '../../../elements/InfoText'
import Status from '../../../elements/Status'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import { Link } from 'react-router-dom'
import { streamUrl } from '../../../variables/index'
import Authentication from '../../../modules/Authentication'
import EmailCont from '../../Common/Email/EmailCont'
import CustomTable from '../../../elements/Table/CustomTable'
import IconText from '../../../elements/IconText'
import BoolFilter from '../../../elements/Select/BoolFilter'
import BoolCell from '../../../elements/Table/Cells/BoolCell'
import DateCell from '../../../elements/Table/Cells/DateCell'
import MoneyCell from '../../../elements/Table/Cells/MoneyCell'

import DateFilter, { dateFilterMethod } from '../../../elements/Table/Filters/Date'
import SumFooter from '../../../elements/Table/Footers/SumFooter'

const CheckboxTable = checkboxHOC(CustomTable)
const ids = idMaker()
const auth = new Authentication()
const columns = [
  {
    Header: 'Code',
    accessor: 'code',
    Cell: ({ original, value }) => {
      return (
        <Link to={`/clients/invoices/${original._key}/view`} style={{ marginLeft: '10px' }}>
          {value}
        </Link>
      )
    },
  },
  {
    Header: 'Revision',
    accessor: 'revision',
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Invoice Date',
    accessor: 'date',
    Cell: DateCell,
    Filter: DateFilter,
    filterMethod: dateFilterMethod,
  },
  {
    Header: 'Invoice Due',
    accessor: 'dueDate',
    Cell: DateCell,
    Filter: DateFilter,
    filterMethod: dateFilterMethod,
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Created Date',
    accessor: '_history.created.date',
    Cell: DateCell,
    Filter: DateFilter,
    filterMethod: dateFilterMethod,
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Company',
    accessor: 'company.fn',
    width: 200,
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Client',
    accessor: 'client.fn',
    width: 200,
  },
  {
    Header: 'MAC',
    accessor: 'enquiry.code',
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Title',
    accessor: 'title',
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Contract',
    accessor: 'contract.code',
    hideable: true,
  },
  {
    Header: 'Sales',
    accessor: 'order.code',
    hideable: true,
  },
  {
    Header: 'CPO',
    accessor: 'cpo.no',
    hideable: true,
    hideDefault: false,
  },
  {
    Header: 'Currency',
    accessor: 'currency',
  },
  {
    Header: 'Amount (NET)',
    accessor: 'subTotal.net',
    style: { textAlign: 'right' },
    Cell: MoneyCell,
    Footer: SumFooter,
  },
  {
    Header: 'Amount (GROSS)',
    accessor: 'subTotal.gross',
    style: { textAlign: 'right' },
    Cell: MoneyCell,
    Footer: SumFooter,
  },
  {
    Header: 'Credited Invoice',
    accessor: 'credited._key',
    hideable: true,
    hideDefault: true,
    Cell: ({ value }) => {
      return (
        <Link to={`/clients/invoices/${value}/view`} style={{ marginLeft: '10px' }}>
          {value}
        </Link>
      )
    },
  },
  {
    Header: 'Tax Filed',
    accessor: 'taxFiled',
    hideable: true,
    hideDefault: true,
    Cell: BoolCell,
  },
  {
    Header: 'Posted',
    accessor: 'posted',
    Cell: ({ value }) => <Tag color={value ? 'blue' : 'red'}>{value ? 'Posted' : 'Not Posted'}</Tag>,
    filterMethod: filterCheckedColumns,
    Filter: BoolFilter,
    zIndex: 90,
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: ({ original, value }) => <Status tooltip={false} value={value} />,
    zIndex: 91,
  },
  {
    Header: 'Issue Date',
    accessor: 'issuance.date',
    Cell: DateCell,
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Issued',
    accessor: 'issuance.issued',
    filterMethod: filterCheckedColumns,
    Filter: BoolFilter,
    Cell: BoolCell,
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'PDF Perview',
    accessor: '_id',
    Cell: ({ value }) =>
      value && (
        <a target={'_blank'} href={`${streamUrl}pdf/${value}?access_token=${auth.getAccessToken()}`}>
          <IconText text={'PDF preview'} type={'file-pdf'} />
        </a>
      ),
    hideable: true,
    hideDefault: true,
  },
  /*{
    Header: 'File',
    accessor: 'file',
    zIndex: 100,
    Cell: FileCell,
  },*/
]

function List(props) {
  const {
    fetching,
    fetchingEmailTemplate,
    fetch,
    showEmail,
    list,
    selection,
    company,
    clearSelection,
    filterCompany,
    toggleSelection,
    toggleAll,
    isSelected,
    selectAll,
    tableRef,
    visibleEmail,
    emailDetails,
    emailFiles,
    type,
    emailLines,
    emailTemplate,
    onCancelEmail,
  } = props

  const checkboxProps = {
    selectType: 'checkbox',
    selectAll,
    isSelected,
    toggleSelection,
    toggleAll,
  }

  const selectionData = selection.map((s) => list.find((p) => get(p, '_id') === s))

  const isFundRequest = type === 'RequestFunds'
  const filter = (i) => (isFundRequest ? i.type === 'Funds Request' : i.type !== 'Funds Request')
  const filteredList = list.filter(filter)

  console.log({ type, isFundRequest, filteredList })
  console.log(23, { selectionData })
  return (
    <Fragment>
      <EmailCont
        key={ids.next().value}
        visible={visibleEmail}
        onCancel={onCancelEmail}
        template={emailTemplate}
        email={emailDetails}
        files={emailFiles}
        lines={emailLines}
      />

      <CheckboxTable
        {...checkboxProps}
        withRef={tableRef}
        columns={columns.map((c) => ({
          style: { textAlign: 'center' },
          ...c,
        }))}
        data={filteredList}
        isFilterable={true}
        ExtraOptionsButtons={() => (
          <OrganisationsSelect
            onChange={filterCompany}
            value={company}
            placeholder={'Filter by a company'}
            size={'small'}
            style={{ width: '450px', paddingRight: 20, float: 'right' }}
          />
        )}
        fetching={fetching}
        fetch={fetch}
        show={{
          csv: {
            fileName: 'Remittance',
          },
          extraColumns: true,
        }}
        ExtraButtons={() => (
          <span className="flex space-x-2">
            {isFundRequest ? (
              <RequestFundsCont />
            ) : (
              <>
                <PaymentButton lines={selectionData} clearSelection={clearSelection} amountAccessor="subTotal.gross" />
                <Button
                  size={'small'}
                  icon={'mail'}
                  loading={fetchingEmailTemplate}
                  onClick={showEmail}
                  disabled={selection.length === 0}
                  style={{ float: 'left' }}>
                  Email Issuance
                </Button>
              </>
            )}
          </span>
        )}
        defaultPageSize={20}
        //style={{ minHeight: '512px', fontSize: 11 }}
      />
      <InfoText text={'Click on the ID to view and update Invoice'} />
      <InfoText text={'Tip: Hold shift when sorting to multi-sort!'} />
    </Fragment>
  )
}

export default List
